import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function DealerCTASection() {
  return <section className="py-28 md:py-36 bg-robeta-black text-white relative overflow-hidden" data-id="element-43">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/5 to-transparent pointer-events-none" data-id="element-44" />

      <div className="container mx-auto px-6 md:px-12 relative z-10 flex flex-col items-center text-center" data-id="element-45">
        <motion.div initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-24 h-px bg-robeta-copper mb-12" data-id="element-46" />

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold uppercase tracking-editorial mb-8 max-w-4xl" data-id="element-47">
          Find Your Nearest
          <br data-id="element-48" />
          Robeta Dealer
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl font-light text-white/70 max-w-2xl mb-12" data-id="element-49">
          Experience the quality firsthand. Visit one of our authorized dealers
          across Canada to tour the Mythos, Apollo, and Helios models.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="inline-block" data-id="element-50">
          <Link to="/dealer-network" className="px-10 py-5 bg-robeta-copper text-robeta-black font-bold uppercase tracking-widest hover:bg-white hover:text-robeta-black transition-all duration-300" data-id="element-51">
            Locate a Dealer
          </Link>
        </motion.div>
      </div>
    </section>;
}